<template>
  <div class="subscription-onboarding">
    <header class="subscription-onboarding__header">
      <div class="subscription-onboarding__header-inner">
        <div class="d-flex align-items-center gap-3 gap-lg-4">
          <img
            alt="Ubbimed"
            :src="require('@/assets/images/logo_ubbi_white.png')"
            class="subscription-onboarding__logo"
          />
          <div class="subscription-onboarding__brand-text">
            <span class="subscription-onboarding__eyebrow">Assinatura</span>
            <span class="subscription-onboarding__title">Sistema de gestão</span>
          </div>
        </div>
        <router-link to="/places" class="btn btn-sm btn-light subscription-onboarding__back">
          <i class="bi bi-arrow-left"></i>
          <span class="d-none d-sm-inline">Voltar aos locais</span>
        </router-link>
      </div>
    </header>

    <main class="subscription-onboarding__main">
      <router-view />
    </main>
  </div>
</template>

<script>
export default {
  name: 'SubscriptionOnboardingLayout',
};
</script>

<style scoped>
.subscription-onboarding {
  --ubbi-primary: #780f5a;
  --ubbi-primary-soft: rgba(120, 15, 90, 0.08);
  --ubbi-primary-mid: rgba(120, 15, 90, 0.14);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #f9f6f8 0%, #f3f6f9 45%, #eef2f6 100%);
}

.subscription-onboarding__header {
  background: linear-gradient(135deg, #780f5a 0%, #9a1a72 55%, #780f5a 100%);
  box-shadow: 0 4px 24px rgba(120, 15, 90, 0.25);
  position: sticky;
  top: 0;
  z-index: 100;
}

.subscription-onboarding__header-inner {
  max-width: 1100px;
  margin: 0 auto;
  padding: 1rem 1.25rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.subscription-onboarding__logo {
  height: 40px;
  width: auto;
}

.subscription-onboarding__brand-text {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.subscription-onboarding__eyebrow {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: rgba(255, 255, 255, 0.75);
  font-weight: 600;
}

.subscription-onboarding__title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #fff;
}

.subscription-onboarding__back {
  font-weight: 600;
  white-space: nowrap;
}

.subscription-onboarding__main {
  flex: 1;
  padding: 2rem 1.25rem 3rem;
}

@media (min-width: 992px) {
  .subscription-onboarding__header-inner {
    padding: 1.15rem 2rem;
  }

  .subscription-onboarding__logo {
    height: 44px;
  }

  .subscription-onboarding__title {
    font-size: 1.25rem;
  }

  .subscription-onboarding__main {
    padding: 2.5rem 2rem 4rem;
  }
}
</style>
